// UtilityContext.tsx

import React, { useState } from "react";

// UtilityContext.tsx

import { createContext } from "react";

interface UtilityContextType {
  showTempMessage: (message: string) => void;
  showTempErrorMessage: (message: string) => void;
}

export const UtilityContext = createContext<UtilityContextType | undefined>(
  undefined
);

export const UtilityProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [popUpMessage, setPopUpMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const showTempMessage = (message: string) => {
    setPopUpMessage(message);
    setTimeout(() => {
      setPopUpMessage(null);
    }, 3000);
  };

  const showTempErrorMessage = (message: string) => {
    setErrorMessage(message);
    setTimeout(() => {
      setErrorMessage(null);
    }, 3000);
  };

  const utilityContextValue: UtilityContextType = {
    showTempMessage,
    showTempErrorMessage,
  };

  return (
    <UtilityContext.Provider value={utilityContextValue}>
      {children}
      {(errorMessage || popUpMessage) && (
        <div className="toast">
          <div
            className={`alert ${
              popUpMessage ? "alert-success" : "alert-warning"
            }`}
          >
            <span>{errorMessage ?? popUpMessage}</span>
          </div>
        </div>
      )}
    </UtilityContext.Provider>
  );
};
